var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('administration-offers-layout',{attrs:{"title":"Список типов статистики","error-text":"Список типов статистики не загружен","api-method":_vm.getEmployeesStats}})
}
var staticRenderFns = []

export { render, staticRenderFns }